<template lang="pug">
  .more-container(v-if="info")
    .coupons-container(:class="[`type-${info.type}`]")
      .title.flex-mid
        .subtitle {{info.title}}
        .price.flex-mid(v-if="info.type!==2")
          div 可省
          .amount {{info.amount}}
          div 元/月
      .coupon(v-for="(coupon, index) in coupons" :key="index")
        .coupon-item(v-for="(item, index) in coupon" :key="index" :class='typeStyle'
        :style="(info.type === 2 && item.status !== 1 && item.status !== 2)?op7:''")
          .coupon-title(v-if="info.type===2")
            img(:src="item.propIcon||'https://m.hellobike.com/resource/helloyun/08345/8c3GjVDzUV.png?x-oss-process=image/quality,q_80'")
            .title-word {{item.goodsPropDesc}}
          .price.flex-mid(v-if="info.type!==2")
            .amount {{item.amount}}
            .unit {{item.unit}}
          .price.flex-mid(v-else)
            span.bigMoney {{getBigMoney(item.amount)}}
            span.smallMoney {{getSmallMoney(item.amount)}}
            span.unit {{item.unit}}
            span.moneyUnit.twoPX x
            span.moneyProp {{item.propNum}}
            span.moneyUnit 张
          .desc(v-if="info.type === 1") {{item.title}}
          .desc(v-else) {{item.subtitle}}
          template(v-if="info.type === 1")
            .icon(:class="['icon-' + item.bizType]")
          .btn.flex-mid(v-if="item.btnName"
            @click="handlerClick(item,index)") {{ getName(item.btnName) }}
</template>

<script>
import { env } from '@hb/hbridge';
import { startApp } from '@/utils/index';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { COUPON_STATUS } from '../../consts';

export default {
  props: {
    info: {
      type: Object,
      default: null,
    },
    indexs: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      status: { ...COUPON_STATUS },
      config: {
        deepLink:
          'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280&beyondMP=true',
      },
      op7: 'opacity: 0.4;',
    };
  },
  computed: {
    coupons() {
      return [this.info.coupons];
    },
    typeStyle() {
      if (this.info.type !== 2) {
        return 'flex-mid';
      }
      return '';
    },
  },
  mounted() {},
  methods: {
    getBigMoney(value) {
      return parseInt(value, 10);
    },
    getSmallMoney(value) {
      if (value % 1 === 0) {
        return '';
      }
      return `${value.toString().substring(value.toString().indexOf('.'), value.length)}`;
    },
    handlerClick(item, index) {
      if (index < 3) {
        UBT.clickButton({
          pageId: 'platform_openedcard_page',
          buttonName: `platform_openedcard_model${index + 1}`,
          categoryId: 'platform',
          businessInfo: {},
        });
      }

      if (env.isEasyBikeApp) {
        if (item.status === this.status.use) {
          this.$emit('use', item);
        } else if (item.status === this.status.receive) {
          this.$emit('receive', item);
        } else if (item.status === this.status.wait) {
          this.$emit('wait', item);
        }
      } else if (item.status === this.status.use) {
        this.goUrl(this.config.deepLink, true);
      } else if (item.status === this.status.receive) {
        this.$emit('receive', item);
      } else if (item.status === this.status.wait) {
        this.$emit('wait', item);
      }
    },
    getName(value) {
      if (!env.isEasyBikeApp) {
        if (value === '去使用') {
          return '去APP使用';
        }
        return value;
      }
      return value;
    },
    goUrl(url = this.config.deepLink, download = false) {
      if (download && (env.isAliMP || env.isAliMPMonitor)) {
        startApp(url);
        return;
      }
      window.location.href = url;
    },
  },
};
</script>

<style lang="less" scoped>
.fontStyle(@fz: 0.16rem, @lh: 0.16rem, @fw: 500, @co: #242729) {
  font-size: @fz;
  line-height: @lh;
  font-weight: @fw;
  color: @co;
}

.more-container {
  .coupons-container {
    flex-direction: column;
    background: #fff;
    border-radius: 0.12rem;

    .title {
      width: 100%;
      justify-content: space-between;
      font-weight: 400;
      padding: 0.16rem 0.2rem 0;

      .subtitle {
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #531900;
        font-size: 0.16rem;
      }

      .price {
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-size: 0.13rem;
        font-weight: 400;
        color: #531900;
        display: flex;

        .amount {
          font-size: 0.16rem;
          font-weight: 600;
          color: #f52e03;
        }
      }
    }

    .coupon {
      white-space: nowrap;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
        color: transparent;
      }
    }

    &.type-1 {
      width: 100%;
      justify-content: flex-start;
      .fontStyle(0.12rem, 0.12rem);

      .title {
        padding: 0.04rem 0.12rem 0 0.2rem;
      }

      .coupon {
        display: flex;
        padding: 0.15rem 0 0 0;

        > :not(:first-child) {
          margin-left: 0.08rem;
        }
      }

      .coupon-item {
        max-width: 0.8rem;
        min-width: 0.8rem;
        height: 0.67rem;
        background: rgba(255, 249, 234, 0.6);
        border-radius: 0.08rem;
        padding: 0.07rem 0 0 0.09rem;
        flex-direction: column;
        align-items: flex-start;
        position: relative;

        .price {
          margin-bottom: 0.04rem;
          align-items: baseline;

          .amount {
            margin-right: 0.02rem;
            .fontStyle(0.22rem, 0.22rem, bold, #fa2a00);
          }

          .unit {
            color: #333;
            position: relative;
            top: -0.01rem;
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-weight: 500;
            line-height: 0.17rem;
          }
        }

        .desc {
          z-index: 2;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          font-size: 0.12rem;
          color: #531900;
        }

        .icon {
          position: absolute;
          bottom: 0;
          right: 0;
          background-size: 100%;
        }

        .icon-null {
          width: 0.28rem;
          height: 0.26rem;
          background-image: url(https://m.hellobike.com/resource/helloyun/08345/q2o8049PC2.png);
        }

        .icon-5 {
          width: 0.28rem;
          height: 0.34rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/ZO4Tn4PJLs.png");
        }

        .icon-7 {
          width: 0.29rem;
          height: 0.31rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/xVapUM1l3J.png");
        }

        .icon-4 {
          width: 0.32rem;
          height: 0.27rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/4riiVa378G.png");
        }

        .icon-8 {
          width: 0.3rem;
          height: 0.29rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/4L-kfZx2_L.png");
        }

        .icon-9 {
          width: 0.29rem;
          height: 0.33rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/MEOqMQv_aQ.png");
        }

        .icon-10 {
          width: 0.27rem;
          height: 0.31rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/w5C83o56Kq.png");
        }

        .icon-11 {
          width: 0.36rem;
          height: 0.3rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/DH9kezwb_2.png");
        }
      }
    }

    &.type-2 {
      width: 100%;
      justify-content: flex-start;
      .fontStyle(0.12rem, 0.12rem);

      .title {
        padding: 0.08rem 0.12rem 0 0.22rem;
      }

      .coupon {
        display: flex;
        padding: 0.16rem 0 0 0;
        overflow-x: auto;

        > :not(:first-child) {
          margin-left: 0.08rem;
        }
      }

      .coupon-item {
        min-width: 0.96rem;
        max-width: 0.96rem;
        height: 1.28rem;
        background-image: url(https://m.hellobike.com/resource/helloyun/08345/kEDrCR0wBW.png?x-oss-process=image/quality,q_80);
        background-size: 100% 100%;
        padding: 0.07rem 0.09rem 0 0.09rem;
        flex-direction: column;
        align-items: flex-start;
        position: relative;

        .coupon-title {
          text-align: center;
          font-size: 0.12rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #531900;
          display: flex;
          justify-content: center;

          img {
            width: 0.16rem;
            height: 0.16rem;
            margin-right: 0.02rem;
            margin-top: -0.02rem;
          }
        }

        .price {
          margin-top: 0.04rem;
          align-items: baseline;

          .bigMoney {
            font-size: 0.28rem;
            font-family: DINAlternate-Bold, DINAlternate, sans-serif;
            font-weight: bold;
            color: #fa4614;
            line-height: 0.42rem;
            margin-top: 0.03rem;
          }

          .smallMoney {
            font-size: 0.12rem;
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-weight: 500;
            color: #fa4614;
            line-height: 0.17rem;
          }

          .moneyUnit {
            font-size: 0.12rem;
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-weight: 500;
            line-height: 0.17rem;
            color: #fa4614;
          }

          .twoPX {
            margin: 0 0.02rem;
          }

          .moneyProp {
            font-size: 0.18rem;
            font-family: DINAlternate-Bold, DINAlternate, sans-serif;
            font-weight: bold;
            line-height: 0.21rem;
            color: #fa4614;
          }

          .unit {
            color: #fa4614;
            position: relative;
            top: -0.01rem;
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-weight: 500;
            line-height: 0.17rem;
          }
        }

        .desc {
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 0.13rem;
          color: #fa4614;
          line-height: 0.18rem;
          text-align: center;
        }

        .btn {
          margin-top: 0.12rem;
          height: 0.22rem;
          background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
          border-radius: 0.12rem;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #fff;
          line-height: 0.22rem;
        }

        .icon {
          position: absolute;
          bottom: 0;
          right: 0;
          background-size: 100%;
        }

        .icon-5 {
          width: 0.28rem;
          height: 0.34rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/ZO4Tn4PJLs.png");
        }

        .icon-7 {
          width: 0.29rem;
          height: 0.31rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/xVapUM1l3J.png");
        }

        .icon-4 {
          width: 0.32rem;
          height: 0.27rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/4riiVa378G.png");
        }

        .icon-8 {
          width: 0.3rem;
          height: 0.29rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/4L-kfZx2_L.png");
        }

        .icon-9 {
          width: 0.29rem;
          height: 0.33rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/MEOqMQv_aQ.png");
        }

        .icon-10 {
          width: 0.27rem;
          height: 0.31rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/w5C83o56Kq.png");
        }

        .icon-11 {
          width: 0.36rem;
          height: 0.3rem;
          background-image: url("https://m.hellobike.com/resource/helloyun/15979/DH9kezwb_2.png");
        }
      }
    }
  }
}

@keyframes placeholder {
  0% {
    background-color: v-bind(bgColor);
  }

  50% {
    background-color: v-bind(bgColorLight);
  }

  100% {
    background-color: v-bind(bgColor);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0%;
  }

  100% {
    opacity: 100%;
  }
}
</style>
